export default __webpack_public_path__ + "static/media/evolution-gaming.7dbf5209.webp";